// extracted by mini-css-extract-plugin
export var dot = "colored-select-option-module--dot--xT6-V";
export var option = "colored-select-option-module--option--OvDzR";